import { useAuth0 } from "@auth0/auth0-react";
import queryString from "query-string";
import { Navigate, useLocation } from "react-router-dom";
import { UserRoles } from "types/enums";
import { roleMatch } from "../actions/auth";
import PageNotFound from "./PageNotFound";
export function RequirePortalAuth({ children, roles }) {
  const location = useLocation();
  const redirectPath = { redirect: location.pathname };
  const { isAuthenticated, isLoading } = useAuth0();
  const isPortalUser = isAuthenticated
    ? roleMatch([UserRoles.PortalUser])
    : false;
  const isPortalAdmin = isAuthenticated
    ? roleMatch([UserRoles.PortalAdmin])
    : false;

  if (isLoading) {
    return <></>;
  }
  if (
    isAuthenticated &&
    (isPortalUser || isPortalAdmin) &&
    roles === undefined
  ) {
    return children;
  }

  if (isAuthenticated && (isPortalUser || isPortalAdmin) && roleMatch(roles)) {
    return children;
  }
  if (isAuthenticated && (isPortalUser || isPortalAdmin) && !roleMatch(roles)) {
    return <PageNotFound />;
  } else {
    return (
      <Navigate
        to={{
          pathname: "/wyloo",
          search: `?${queryString.stringify(redirectPath)}`,
        }}
        state={{ from: location }}
        replace
      />
    );
  }
}
